import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaStar, FaRegHeart, FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import img1 from '../Components/Images/TIJ/tijh1.jpeg'
import img2 from '../Components/Images/esl/lumina_1.png'
import img3 from '../Components/Images/antennas/eas_antenna.png'
import img4 from '../Components/Images/Retail weighing/weighing.png'

const Featuredproduct = () => {
  const navigate=useNavigate()

  

  const products = [
    {
      id: 1,
      name: 'Handheld code printer',
      rating: 4.8,
      image: img1,
      isNew: false,
      stockStatus:'Limited Stock',
      highlight: 'Rechargeable | Touchscreen | Compact',
      url:'/thermal-inkjet-printer'
    },
    {
      id: 2,
      name: 'Retail Weighing Scales',
      rating: 4.5,
      image: img4,
      isNew: false,
      stockStatus:'In stock',
      highlight: 'Dual display | Label printing | Barcode support',
      url:'/retail-scales'
    },
    {
      id: 3,
      name: 'Electronic Shelf Labels',
      rating: 4.8,
      image: img2,
      isNew: true,
      stockStatus:'In stock',
      highlight: 'E-ink display | Wireless sync | Energy-efficient',
      url:'/electronic-shelf-label'
    },
    {
      id: 4,
      name: 'EAS Anti-theft Systems',
      rating: 5.0,
      image: img3,
      isNew: false,
      stockStatus:'Limited Stock',
      highlight: 'High detection rate | Easy integration | Sleek design',
      url:'/eas-system'
    },
  ];

 

  return (
    <section className="featured-products py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-6 fw-bold">Featured <span style={{
            background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            display: "inline-flex",
            alignItems: "center",
            textDecoration: "none",
            marginTop: "auto",
          }}>Products</span> </h2>
          <p className="text-muted">Discover our most popular items</p>
        </div>
        
        <Row className="g-4">
          {products.map((product) => (
            <Col key={product.id} lg={3} md={6}>
              <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
                <div className="position-relative">
                  <Card.Img variant="top" src={product.image} alt={product.name} />
                  {product.isNew && (
                    <span className="badge bg-danger position-absolute top-0 start-0 m-2">New</span>
                  )}
                  <button className="btn btn-sm btn-light position-absolute top-0 end-0 m-2 rounded-circle">
                    <FaRegHeart />
                  </button>
                </div>
                <Card.Body className="d-flex flex-column">
                  <div className="mb-2">
                    <span className="text-warning">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} className={i < Math.floor(product.rating) ? 'fas' : 'far'} />
                      ))}
                    </span>
                    <span className="text-muted ms-2">({product.rating})</span>
                  </div>
                  <Card.Title className="h6 mb-2">{product.name}</Card.Title>
                  <div className="mt-auto">
                    <div className="d-flex align-items-center mb-2">
                      <span className=" mb-0 text-dark" style={{fontFamily:"Poppins"}}>{product.stockStatus}</span>
                      
                      {/* {product.discount && (
                        <span className="text-muted text-decoration-line-through ms-2">
                          ${product.discount}
                        </span>
                      )} */}
                    </div>
                    <div>
                      <span className=" mb-0 text-dark" style={{fontFamily:"Poppins"}}>{product.highlight}</span>

                    </div>

                    <Button variant="dark" className="w-100 mt-3" onClick={()=>{
                       navigate(product.url);
                       window.scrollTo(0, 0);
                    }
                     }>
                      <FaShoppingCart className="me-2" /> Explore Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        {/* <div className="text-center mt-5">
          <Button variant="outline-dark" size="lg">View All Products</Button>
        </div> */}
      </Container>
    </section>
  );
};

export default Featuredproduct;